module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet"
  }, [(_vm.showHeader) ? _c('div', {
    staticClass: "ui-widget-header ui-widget-header-new-layout"
  }, [_c('label', {
    staticClass: "ui-widget-container-titulo",
    attrs: {
      "for": "ui-widget-header.ui-widget-header-new-layout"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.portletTitle)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "ui-widget-content"
  }, [_vm._t("filters")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c75fdef8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c75fdef8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/filterPortlet/filterPortlet.pug
// module id = 1457
// module chunks = 0